import { useState } from "react";
import PropTypes from "prop-types";
import { api } from "api";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function CreateUserDialog({ open, onClose }) {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [formError, setFormError] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        setFormError("");
        if (formData.password !== formData.confirmPassword) {
            setFormError("Passwords do not match");
            return;
        }
        if (!formData.name || !formData.email || !formData.password) {
            setFormError("Please fill all fields");
            return;
        }

        const compCode = localStorage.getItem("comp_code");
        const adminEmail = localStorage.getItem("user_email");

        if (adminEmail && formData.email.toLowerCase() === adminEmail.toLowerCase()) {
            setFormError("Cannot create a user with the same Email ID as the Admin.");
            return;
        }

        try {
            const res = await api.registerUser({
                name: formData.name,
                email: formData.email,
                password: formData.password,
                role: "User",
                compCode: compCode,
            });

            if (res && (res.success || res.message === "User registered successfully" || res.status === 200)) {
                alert("User created successfully!");
                handleClose();
            } else {
                setFormError(res.message || "Failed to create user");
            }
        } catch (err) {
            console.error(err);
            setFormError("An error occurred");
        }
    };

    const handleClose = () => {
        setFormData({ name: "", email: "", password: "", confirmPassword: "" });
        setFormError("");
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", color: "#344767" }}>
                Create New User
            </DialogTitle>
            <DialogContent>
                <MDBox component="form" role="form">
                    <MDBox mb={2} mt={2}>
                        <MDInput
                            type="text"
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            fullWidth
                            variant="outlined"
                        />
                    </MDBox>
                    <MDBox mb={2}>
                        <MDInput
                            type="email"
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            fullWidth
                            variant="outlined"
                        />
                    </MDBox>
                    <MDBox mb={2}>
                        <MDInput
                            type="password"
                            label="Password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            fullWidth
                            variant="outlined"
                        />
                    </MDBox>
                    <MDBox mb={2}>
                        <MDInput
                            type="password"
                            label="Confirm Password"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            fullWidth
                            variant="outlined"
                            error={formData.password !== formData.confirmPassword && formData.confirmPassword.length > 0}
                            helperText={
                                formData.password !== formData.confirmPassword && formData.confirmPassword.length > 0
                                    ? "Passwords do not match"
                                    : ""
                            }
                        />
                    </MDBox>
                    {formError && (
                        <MDTypography variant="caption" color="error" fontWeight="medium" textTransform="none">
                            {formError}
                        </MDTypography>
                    )}
                </MDBox>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                <MDButton onClick={handleClose} color="error" variant="contained" sx={{ mr: 1 }}>
                    CANCEL
                </MDButton>
                <MDButton onClick={handleSubmit} color="success" variant="contained">
                    CREATE
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}

CreateUserDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default CreateUserDialog;
